import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { useSlotGroup, EditableSlotGroup } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';

/**
 * Deals page promo image — sits below the shared PageBlurb, matching the
 * simple blurb + content layout used on other inner pages. Adapted from the
 * Weidner Preferred theme's Deals component for this Aster-based theme.
 */

const imageDef: SlotGroupDefinition = {
  label: 'Promo Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultValue:
        'https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/5122712762580992/019fae70-64a9-737c-bd22-a02e41f70377.webp',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'CORT furniture rental deals',
    },
  },
};

export function Deals() {
  const image = useSlotGroup('deals.image', imageDef);

  return (
    <section className="deals-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <EditableSlotGroup groupPath="deals.image" definition={imageDef}>
          {image.image ? (
            <div className="deals-image-wrap">
              <VibesitesImage
                url={image.image}
                alt={image.alt || 'CORT furniture rental deals'}
                className="w-full h-auto"
                sizes="(max-width: 768px) 100vw, 768px"
              />
            </div>
          ) : (
            <div className="deals-image-placeholder" aria-label="Promo image placeholder" />
          )}
        </EditableSlotGroup>
      </div>

      <style>{`
        .deals-section {
          padding: 0.5rem 0 3rem;
          background: var(--vibe-color-background);
        }
        @media (min-width: 768px) {
          .deals-section { padding: 0.75rem 0 4rem; }
        }
        .deals-image-wrap {
          overflow: hidden;
        }
        .deals-image-placeholder {
          width: 100%;
          aspect-ratio: 4 / 5;
          background: var(--vibe-color-surface, #f3f3f3);
        }
      `}</style>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'Deals',
  displayName: 'Deals',
  tokens: {},
  slotGroups: {
    'deals.image': imageDef,
  },
};

(Deals as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default Deals;
